import { useState, useEffect } from 'react';
import { cmsApi } from '@/services/api';

/**
 * Hook för att hämta CMS-innehåll från backend.
 * Används av statiska sidor (Om oss, Köpvillkor, etc.)
 */
export const useCMSContent = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await cmsApi.getContent();
        setContent(res.data);
      } catch (error) {
        console.error('Could not fetch CMS content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  return { content, loading };
};
